import React from "react";
import { Button, Box, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CorporateFareOutlinedIcon from "@mui/icons-material/CorporateFareOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import { useAuth } from "../utils/AuthContext";
import MFR from "../config/manufacturers";

const ALL_ROLES = ["admin", "viewer", "team_member", "manager", "file_limited"];
const INTERNAL_ROLES = ["admin", "viewer", "team_member", "manager"];

const allPages = [
  {
    name: "Organizations",
    path: "/orgs",
    icon: <CorporateFareOutlinedIcon />,
    allowedRoles: INTERNAL_ROLES,
    allowedManufacturers: MFR.orgs,
  },
  {
    name: "Summary",
    path: "/summary",
    icon: <SummarizeOutlinedIcon />,
    allowedRoles: INTERNAL_ROLES,
    allowedManufacturers: MFR.summary,
  },
  {
    name: "Tasks",
    path: "/tasks",
    icon: <AssignmentOutlinedIcon />,
    allowedRoles: ALL_ROLES,
    allowedManufacturers: MFR.tasks,
  },
  {
    name: "Files",
    path: "/file/files",
    icon: <FolderOutlinedIcon />,
    allowedRoles: ALL_ROLES,
    allowedManufacturers: MFR.files,
  },
  {
    name: "Report Files",
    path: "/reports",
    icon: <DescriptionOutlinedIcon />,
    allowedRoles: ALL_ROLES,
    allowedManufacturers: MFR.reports,
  },
  {
    name: "Reports",
    path: "/reports-table",
    icon: <AssessmentOutlinedIcon />,
    allowedRoles: ALL_ROLES,
    allowedManufacturers: MFR.reports,
  },
  {
    name: "Admin Users",
    path: "/admin/users",
    icon: <PeopleAltOutlinedIcon />,
    allowedRoles: ["admin"],
    allowedManufacturers: MFR.admin,
  },
  {
    name: "Admin Logs",
    path: "/admin/logs",
    icon: <HistoryOutlinedIcon />,
    allowedRoles: ["admin"],
    allowedManufacturers: MFR.admin,
  },
];

const Sidebar = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const role = user?.role || null;
  const manufacturer = user?.manufacturer || null;

  const filteredPages =
    role && manufacturer
      ? allPages.filter(
          (page) =>
            page.allowedRoles.includes(role) &&
            page.allowedManufacturers.includes(manufacturer),
        )
      : [];

  return (
    <Box
      sx={{
        position: "fixed",
        top: "64px",
        left: 0,
        height: "calc(100vh - 64px)",
        width: "72px",
        backgroundColor: "white",
        padding: "16px 0",
        display: "flex",
        flexDirection: "column",
        zIndex: 1100,
        boxShadow: "2px 0 4px rgba(0,0,0,0.1)",
        overflow: "visible",
      }}
    >
      <Stack spacing={1} sx={{ width: "100%", px: "8px" }}>
        {filteredPages.map((page) => (
          <Button
            key={page.path}
            variant="outlined"
            color="inherit"
            sx={{
              minWidth: "56px",
              width: "56px",
              height: "40px",
              p: 0,
              borderRadius: "20px",
              border: "1px solid #ddd",
              justifyContent: "flex-start",
              overflow: "visible",
              transition: "all 0.3s ease",
              backgroundColor: "white",
              position: "relative",
              zIndex: 1101,
              "&:hover": {
                backgroundColor: "#f5f5f5",
                width: "200px",
                "& .button-text": {
                  opacity: 1,
                  width: "auto",
                  ml: "12px",
                  transition: "opacity 0.2s ease 0.1s",
                },
              },
            }}
            onClick={() => navigate(page.path)}
          >
            <Box
              sx={{
                minWidth: "56px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {page.icon}
            </Box>
            <Typography
              className="button-text"
              sx={{
                opacity: 0,
                width: 0,
                overflow: "hidden",
                whiteSpace: "nowrap",
                fontFamily: "Poppins, sans-serif",
                fontSize: "14px",
                fontWeight: 500,
              }}
            >
              {page.name}
            </Typography>
          </Button>
        ))}
      </Stack>
    </Box>
  );
};

export default Sidebar;
